// extracted by mini-css-extract-plugin
export var divider = "_k4-0";
export var systemMessage = "_k4-1";